import React, { memo, type ReactNode } from 'react';
import { styled } from '@compiled/react';
import EmptyState from '@atlaskit/empty-state';
import ErrorIllustration from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/error/components/error/index.tsx';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const MAX_IMAGE_WIDTH_PX = 188;
const MAX_IMAGE_HEIGHT_PX = 250;
const IMAGE_WIDTH_PX = 188;

const renderImage = () =>
	getAkEmptyStateRenderImageFn(ErrorIllustration)({
		imageWidth: IMAGE_WIDTH_PX,
		maxImageWidth: MAX_IMAGE_WIDTH_PX,
		maxImageHeight: MAX_IMAGE_HEIGHT_PX,
	});

const ErrorState = memo(() => {
	const { formatMessage } = useIntl();

	return (
		<DataIdWrapper data-test-id="issue-create.ui.modal.error-state.fetch-error">
			<EmptyState
				renderImage={renderImage}
				header={formatMessage(messages.header)}
				description={formatMessage(messages.description)}
				width="narrow"
			/>
		</DataIdWrapper>
	);
});

export default ErrorState;

// to be wrapped only for components where test-id can't be added on some components
// eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DataIdWrapper = styled.div<{
	children?: ReactNode;
	['data-test-id']?: string;
	['data-testid']?: string;
}>({});
